<template>
    <div>
        <div class="search-field">
            <b-dropdown v-bind:text="pages[term]" :key="'dropdown-'+updateKey">
                <b-dropdown-item v-for="(name,i) in pages" v-on:click="setPage(i)" :key="index">{{name}}</b-dropdown-item>
            </b-dropdown>
        </div>

        <layout-14 :key="updateKey" :term=term :page="pageIds[term]" :roleEditPage="roleEditPageId" style="height:calc(100vh - 110px);"></layout-14>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props:{
		term: {
			type: Number,
			required: false,
			default: 0
		},
	},
	data() {
		return {
            pages:['Roles','Users','Permissions','Locks'],
            updateKey:0,
            pageIds:[PAGES.ROLES_PAGE,PAGES.USERS_PAGE,PAGES.PERMISSIONS_PAGE,PAGES.LOCKS_PAGE],
            roleEditPageId:PAGES.EDIT_ROLES_PAGE,
		}
	},
	methods: {
        setPage(index){
            this.term=index;
            router.push('/0208?q='+this.term);
            this.updateKey++;
        },
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Permissions.vue